import {Level} from '../level/level';
import {Address} from '../address/address';

export class Project {

  public id: number;
  public level: number;
  public name: string;
  public code: string;
  public description: string;
  public documentUrl : string;
  public address: Address = new Address();
  public startDate: string;
  public endDate: string;
  //  public send_expiration: number;
  public latitude: number;
  public longitude: number;
  public zoom: number;
  public active: boolean;
  public archive: boolean;
  public project_device_locations_count: number;
  public project_device_locations_gps_count: number;
  public project_plans_count: number;
  // public project_plans: any[];
  // public note_project_users_current: any;


  public setProject(data: any) {
    this.id = data.id;
    this.level = data.level.id;
    this.name = data.name;
    this.code = data.code;
    this.description = data.description;
    this.documentUrl = data.document_url;
    this.address.setAddress(data.address);
    this.startDate = data.start_date;
    this.endDate = data.end_date;
    //  this.send_expiration = data.send_expiration;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.zoom = data.zoom;
    this.archive = data.archive;
    this.project_device_locations_count = data.project_device_locations_count;
    this.project_device_locations_gps_count = data.project_device_locations_gps_count;
    this.project_plans_count = data.project_plans_count;
  }
}
